exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/* Colors */\n/* Sizes */\n/* Breakpoints */\n/* Mobile */\n/* Fonts */\n.SideContent__sideContent___oE6Jmz9P.SideContent__scrolled___1IknaVRX {\n  overflow-y: hidden;\n}\n.SideContent__sideContent___oE6Jmz9P.SideContent__fullContent___1UubNUwb {\n  overflow-y: auto;\n}\n.SideContent__fullContent___1UubNUwb .SideContent__sideMain___3AQCRc1L {\n  color: red;\n  max-height: none;\n}\n.SideContent__sideMain___3AQCRc1L {\n  overflow-y: auto;\n  background-color: #F5F5F5;\n}\n", ""]);
// Exports
exports.locals = {
	"sideContent": "SideContent__sideContent___oE6Jmz9P",
	"scrolled": "SideContent__scrolled___1IknaVRX",
	"fullContent": "SideContent__fullContent___1UubNUwb",
	"sideMain": "SideContent__sideMain___3AQCRc1L"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader/dist/cjs.js??ref--3-oneOf-0-1!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib??vue-loader-options!./node_modules/eslint-loader??ref--0!./src/layouts/SideContent.vue?vue&type=style&index=0&lang=scss&module=true&
// module id = JY1J
// module chunks = 3